<div class="dialog-container">
    <mat-form-field>
      <mat-label>Select Column</mat-label>
      <mat-select (selectionChange)="addColumn($event.value)">
        <mat-option *ngFor="let column of allColumns" [value]="column">{{ bus_nm[column] }}</mat-option>
      </mat-select>
    </mat-form-field>
  
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" cdkDropList  [cdkDropListData]="dataSource" (cdkDropListDropped)="drop($event)">
      <ng-container matColumnDef="sequence">
        <th mat-header-cell *matHeaderCellDef>Seq</th>
        <td mat-cell *matCellDef="let index = index">{{ index + 1 }}</td>
      </ng-container>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Column Name</th>
        <td mat-cell *matCellDef="let column">{{ bus_nm[column.name] }}</td>
      </ng-container>
  
      <ng-container matColumnDef="sortOrder">
        <th mat-header-cell *matHeaderCellDef>Sort Order</th>
        <td mat-cell *matCellDef="let column">
          <button mat-icon-button (click)="toggleSortOrder(column.name)">
            <mat-icon>{{ column.sortOrder === 'ASC' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="['sequence', 'name', 'sortOrder']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['sequence', 'name', 'sortOrder']"    
      cdkDrag [cdkDragData]=row></tr>
    </table>
  <br>
    <div class="button-container">
      <button mat-button  (click)="apply()">Apply</button>
      <button mat-button style="background-color: red;" color="danger" (click)="cancel()">Cancel</button>
    </div>
  </div>
  